export enum ENUM_LANGUAGES {
  UZ = "UZ",
  EN = "EN",
  RU = "RU",
  KR = "KR",
}

export enum ENUM_LANGUAGES_NUM {
  UZ = 1,
  EN = 2,
  RU = 3,
  KR = 4,
}
